import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const ValidSession = ({ dataSession = null, customPath = '' }) => {

    const [pathRedirect, setPathRedirect] = useState('');
    useEffect(() => {
        if(!dataSession) setPathRedirect(customPath !== '' ? customPath : '/');
    }, []);

    return (
        <>
        {pathRedirect!=='' && <Redirect to={pathRedirect} />}
        </>
    )
}

ValidSession.propTypes = {
    dataSession: PropTypes.object, 
    customPath: PropTypes.string
};
export default ValidSession;